function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8702 10.3399C21.0572 10.3399 22.8302 8.56697 22.8302 6.37992C22.8302 4.19287 21.0572 2.41992 18.8702 2.41992C16.6831 2.41992 14.9102 4.19287 14.9102 6.37992C14.9102 8.56697 16.6831 10.3399 18.8702 10.3399Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.74 12.0098H17.02C14.25 12.0098 12 14.2598 12 17.0298V18.4098H25.76V17.0298C25.76 14.2498 23.51 12.0098 20.74 12.0098Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7599 18.4102H9.91992V19.0002H25.7599V18.4102Z",
  fill: "#CE2D2D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.87016 10.3399C9.0572 10.3399 10.8302 8.56697 10.8302 6.37992C10.8302 4.19287 9.0572 2.41992 6.87016 2.41992C4.68311 2.41992 2.91016 4.19287 2.91016 6.37992C2.91016 8.56697 4.68311 10.3399 6.87016 10.3399Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.74 12.0098H5.02C2.25 12.0098 0 14.2498 0 17.0298V18.4098H13.76V17.0298C13.76 14.2498 11.51 12.0098 8.74 12.0098Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.84 18.4102H0V19.0002H13.84V18.4102Z",
  fill: "#FF5C14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8295 9.12C15.3479 9.12 17.3895 7.07842 17.3895 4.56C17.3895 2.04158 15.3479 0 12.8295 0C10.3111 0 8.26953 2.04158 8.26953 4.56C8.26953 7.07842 10.3111 9.12 12.8295 9.12Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7399 11.04H9.93992C7.16992 11.04 4.91992 13.29 4.91992 16.06V18.41H20.7599V16.06C20.7599 13.29 18.5099 11.04 15.7399 11.04Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7599 18.4102H4.91992V19.0002H20.7599V18.4102Z",
  fill: "#EFAF0B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 18.8714,
  y1: 10.2275,
  x2: 18.8714,
  y2: 2.30352,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E73D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED5959"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 18.8804,
  y1: 18.3163,
  x2: 18.8804,
  y2: 11.9134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E73D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED5959"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 6.87136,
  y1: 10.2275,
  x2: 6.87136,
  y2: 2.30352,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA74F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 6.8804,
  y1: 18.3163,
  x2: 6.8804,
  y2: 11.9134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA74F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 12.8289,
  y1: 8.9906,
  x2: 12.8289,
  y2: -0.1316,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC518"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE183"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 12.84,
  y1: 18.3025,
  x2: 12.84,
  y2: 10.9315,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC518"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE183"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.76,
  height: 19,
  fill: "white"
})));

var SvgCustomerIcon = function SvgCustomerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-icon.298505c1.svg";
export { ForwardRef as ReactComponent };